/* eslint-disable no-console */

import { register } from "register-service-worker";

// On an uncontrolled page (e.g. the very first visit) the library routes
// update installs to cached() instead of updated(), so a repeat install
// during one page lifetime is an update and must be announced too.
let hasInstalledOnce = false;

if (import.meta.env.PROD) {
  register(`${import.meta.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      setInterval(() => {
        registration.update();
      }, 20000);
    },
    cached(registration) {
      console.log("Content has been cached for offline use.");
      if (hasInstalledOnce) {
        document.dispatchEvent(
          new CustomEvent("swUpdated", { detail: registration })
        );
      }
      hasInstalledOnce = true;
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available!; please refresh.");
      // const confirmationResult = confirm(
      document.dispatchEvent(
        new CustomEvent("swUpdated", { detail: registration })
      );
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
} else if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()));
}
